import React from "react";
import styles from "../highlights.module.css";

interface HighlightCardComponentProps {
  title: string;
  status?: string | null;
  statusIcon?: React.ReactNode;
  value: string;
  description: string;
  graphComponent?: React.ReactNode;
}

const HighlightCard: React.FC<HighlightCardComponentProps> = ({ title, status, statusIcon, value, description, graphComponent }) => {

  return (
    <div className={styles.highlightCard}>
      <h3 className={styles.highlightCardTitle}>{title}</h3>
      <div className={styles.highlightCardGraph}>
        {graphComponent}
      </div>
      <div className={styles.highlightCardContent}>
        <span className={styles.temperature}>{statusIcon} {value}</span>
        {/* <div className={styles.description}>
          <p className={styles.status}>
            {status} {statusIcon}
          </p>
          <p className={styles.details}>
            {description}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export { HighlightCard };
